import { Component, Inject, OnDestroy } from '@angular/core';

import { ProductConfig } from 'app/product-designer-config';
import { AdditionalInfoItemConfig
       } from 'collage-designer/collage-designer-config';
import { StageService } from 'collage-designer/stage/stage.service';
import { ProductService } from 'core/product/product.service';
import { AsyncEventEmitterSubscriber
       } from 'core/utils/async-event-emitter';
import { TemplateConfig } from '../collage-designer-config';
import { DesignStepService } from '../design-step/design-step.service';
import { AdditionalInfoItemInterface
       } from './additional-info-item-interface';

@Component({
  selector: 'advent-calendar-overlay',
  template: ``,
  styleUrls: ['./advent-calendar-overlay.component.scss']
})
export class AdventCalendarOverlayComponent
    implements AdditionalInfoItemInterface, OnDestroy
{
  private static readonly CATALOG_PRODUCT_ID: RegExp =
      /^smart-sorted-.*puzzle.*-1000-advent-calendar$/;

  public removeComponent: () => void;
  public SMASOConfig: ProductConfig|undefined;

  private templateChangedSubscription:
      AsyncEventEmitterSubscriber<TemplateConfig>;

  constructor (
      @Inject(DesignStepService) private designStepService: DesignStepService,
      @Inject(StageService) private stageService: StageService,
      @Inject(ProductService) private productService: ProductService)
  {
    this.templateChangedSubscription =
        this.designStepService.templateChanged.subscribe(
            async (templateConfig) => {
              this.removeOverlay();
              this.removeComponent();
            });
  }

  public ngOnDestroy(): void
  {
    this.removeOverlay();
    this.designStepService.templateChanged.unsubscribe(
        this.templateChangedSubscription);
  }

  public async initComponent(
      additionalInfoItem: AdditionalInfoItemConfig): Promise<void>
  {
    const stage = document.querySelector('.stage-svg-container');
    const stageConfig = this.stageService.getCurrentStageState().stageConfig;

    const close = document.createElement('img');
    close.classList.add('advent-calendar-overlay-close');
    close.src = 'assets/img/additional-info-item-components/' +
                'advent-calendar-overlay/close.svg';
    close.onclick = () => {
      this.removeOverlay();
      this.removeComponent();
    };

    const closeDiv = document.createElement('div');
    closeDiv.classList.add('advent-calendar-overlay-close-div');
    if (stageConfig.rotation !== 0) {
      if (!('ResizeObserver' in window)) {
        closeDiv.style.width = '0px';
      }
      else {
        // @ts-ignore: TS2304: Cannot find name 'ResizeObserver'
        const observer = new ResizeObserver(() => {
          closeDiv.style.width =
              stage.querySelector('svg').clientHeight * 0.76 + 'px';
        });
        observer.observe(stage);
      }
    }
    closeDiv.appendChild(close);
    stage.insertBefore(closeDiv, stage.firstChild);

    const img = document.createElement('img');
    img.classList.add('advent-calendar-overlay');
    if (stageConfig.rotation === 0) {
      img.src = 'assets/img/additional-info-item-components/' +
                'advent-calendar-overlay/raster-landscape.svg';
    }
    else {
      img.src = 'assets/img/additional-info-item-components/' +
                'advent-calendar-overlay/raster-portrait.svg';
    }
    stage.insertBefore(img, stage.firstChild);

  }

  private removeOverlay(): void
  {
    const closeDiv = document.querySelector(
        '.advent-calendar-overlay-close-div');
    if (closeDiv) {
      closeDiv.remove();
    }

    const img = document.querySelector('.advent-calendar-overlay');
    if (img) {
      img.remove();
    }
  }

  public async isApplyable(): Promise<boolean>
  {
    return AdventCalendarOverlayComponent.CATALOG_PRODUCT_ID
      .test(this.productService.getCurrentProduct().id);
  }
}



// WEBPACK FOOTER //
// ./src/app/collage-designer/additional-info-item-components/advent-calendar-overlay.component.ts